export default "__VITE_ASSET__DAatNiZV__"